// Import builderFetch
import { builderFetch } from '../../utils';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __ } from '@wordpress/i18n';

/**
 * Sets a new recipe type
 *
 * @param {String} recipeType The recipe type (e.g. user)
 * @return {Promise|undefined} The apiFetch promise
 */
const setRecipeType = ( recipeType ) => {
	// Event name
	const eventName = 'uap/builder/core/set-recipe-type';

	// Check if the recipe type selected is valid
	if ( ! [ 'user', 'anonymous' ].includes( recipeType ) ) {
		return;
	}

	// Save the recipe title
	return builderFetch( {
		eventName: eventName,
		endpoint: 'change_post_recipe_type',
		method: 'POST',
		data: {
			// eslint-disable-next-line camelcase
			post_ID: UncannyAutomator._recipe.recipe_id,
			// eslint-disable-next-line camelcase
			recipe_type: recipeType
		},
		snackbar: {
			loading: escapeHTML( __( 'Setting recipe type', 'uncanny-automator' ) ),
			success: escapeHTML( __( 'Recipe type set successfully', 'uncanny-automator' ) ),
		}
	} ).then( response => {
		// Check if the call was successful
		if ( response.success ) {
			// Send custom event to the document
			document.dispatchEvent( new CustomEvent( eventName, {
				detail: {
					recipeType: recipeType
				}
			} ) );
		}

		return response;
	} );
}

export default setRecipeType;
